import { useCallback, useEffect, useState } from "react";
import { getData, postData } from "../../helpers/api";
import moment from "moment";
import { Button, Col, Row } from "antd";
import TableLayout from "../../components/layouts/TableLayout";
import { Formik, Form } from "formik";
import * as Yup from 'yup';
import SelectInput from "../../components/inputs/SelectInput";
import TextInput from "../../components/inputs/TextInput";
import { getLocalStorage } from "../../helpers/localstorage";
import { rolesConst } from "../../constants/others";
import PaymentCard from "../../components/PaymentCard";
import { DollarOutlined } from "@ant-design/icons"

const DeliveryManPayment = () => {
    const user = getLocalStorage("auth")?.user;
    const [paymentData, setPaymentData] = useState({
        payments: [],
        total: 0
    })
    const [paymentStats, setPaymentStats] = useState({
        develiveryManPayments: 0,
        payed: 0,
        restToPay: 0,
        totalToPay: 0
    })
    const [users, setUsers] = useState([])
    const [selectedUserId, setSelectedUserId] = useState(null)

    useEffect(() => {
        if (user.role === rolesConst.Deliveryman) {
            setSelectedUserId(user.id)
        }
    }, [user.role, user.id])
    const getUsers = async () => {
        try {
            const res = await getData('/users/deliverymen')
            setUsers(res.data.map((user) => ({ value: user.id, label: user.name })))
        } catch (error) {

        }
    }
    const getDeliveryManPayment = async (page = 1, limit = 10, userId = null) => {
        try {
            console.log(userId)
            const res = await getData('payment/delivery-man', { page, limit, userId })
            setPaymentData(res.data)
        } catch (error) {
            console.log(error)
        }
    }

    const validatePayment = async (paymentId) => {
        try {
            await postData(`payment/${paymentId}`)
            getDeliveryManPayment(1, 10, selectedUserId)
        } catch (error) {

        }
    }
    const paymentColumns = [
        {
            title: "Payment",
            dataIndex: "payment",
            key: "payment",
        },
        {
            title: "Date de payment",
            dataIndex: "createdAt",
            key: "createdAt",
            render: (text) => <div>{moment(text).format('YYYY-MM-DD')}</div>
        },
        {
            title: "Actions de payment",
            dataIndex: "actions",
            render: (text, record) => {
                return (
                    <>
                        {record.isPayed ? <Button type="primary" disabled>Payé</Button> :
                            <Button disabled={user.role !== rolesConst.SuperAdmin} onClick={() => { validatePayment(record.id) }} type="primary">{user.role !== rolesConst.SuperAdmin ? "en attente de confirmation" : "comfirmer le payment"}</Button>}
                    </>
                )
            },
        }
    ]
    const addPayment = async (payment) => {
        try {
            await postData('/payment', {
                user: parseInt(selectedUserId),
                payment,
                totalUnitsUpSell: 0,
                totalDeliveredOrders: 0,
                totalUnitsCruSell: 0,
            })
            getDeliveryManPayment(1, 10, selectedUserId)
        } catch (error) {

        }
    }

    const getStatsDelevryMan = useCallback(async () => {
        try {
            const res = await getData('payment/delivery-man-states', { userId: selectedUserId })
            setPaymentStats(res.data)
        } catch (error) {

        }
    }, [selectedUserId])
    useEffect(() => {
        getDeliveryManPayment()
        getUsers()
        getStatsDelevryMan()
    }, [getStatsDelevryMan])

    const getPayamentsStats = async () => {
        try {
            const res = await getData('/payment/delivery-man-states')
            console.log(res)
        } catch (error) {

        }
    }
    return (
        <>
            <Row>
                {user.role !== rolesConst.Deliveryman && <Col span={8}>
                    <Formik
                        initialValues={{ userId: null }}
                        validationSchema={Yup.object({
                            userId: Yup.number().required('required'),
                        })}
                        onSubmit={(values, _) => {
                            setSelectedUserId(values.userId)
                            getDeliveryManPayment(1, 10, values.userId)
                        }}
                    >
                        <Form>
                            <Row gutter={[16, 16]}>
                                <Col span={24} style={{ textAlign: "left" }}>Selectionner un livreur</Col>
                                <Col span={12}>
                                    <SelectInput
                                        name="userId"
                                        size="large"
                                        placeholder={"Livreur"}
                                        options={users}
                                    />
                                </Col>
                                <Col span={8}>
                                    <Button size='large' type="primary" htmlType="submit">
                                        Selectionner
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Formik>
                </Col>}
                {user.role === rolesConst.Deliveryman && <Col span={8} offset={8}>
                    <Formik
                        initialValues={{ payment: null }}
                        validationSchema={Yup.object({
                            payment: Yup.number().required('required'),
                        })}
                        onSubmit={(values, submitProps) => {
                            addPayment(values.payment)
                        }}
                    >
                        <Form>
                            <Row gutter={[16, 16]}>
                                <Col span={24} style={{ textAlign: "left" }}>Ajouter paiement</Col>
                                <Col span={12} >
                                    <TextInput
                                        name="payment"
                                        placeholder="Montant"
                                        size="large"
                                    />
                                </Col>
                                <Col span={8}>
                                    <Button size='large' type="primary" htmlType="submit">
                                        Ajouter
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Formik>
                </Col>}
            </Row>
            <Row gutter={[14, 20]} style={{ marginTop: 10 }}>
                <PaymentCard
                    value={paymentStats.develiveryManPayments + " DH"}
                    title="Livreur montant"
                    icon={<DollarOutlined />}
                />
                <PaymentCard
                    value={(paymentStats.payed || 0) + " DH"}
                    title="Montant total payé"
                    icon={<DollarOutlined />}
                />
                <PaymentCard
                    value={(paymentStats.totalToPay || 0) + " DH"}
                    title="total à payer par le Lvr"
                    icon={<DollarOutlined />}
                />
                <PaymentCard
                    value={paymentStats.restToPay + " DH"}
                    title="restant à payer par le Lvr"
                    icon={<DollarOutlined />}
                />
            </Row>
            <TableLayout
                columns={paymentColumns}
                total={paymentData.total}
                dataSource={paymentData.payments}
                getData={getDeliveryManPayment}
                displayAddBtn={true}
            />
        </>
    );
}

export default DeliveryManPayment;